import { render } from "./resourceImgVideo.vue?vue&type=template&id=113b3b44&scoped=true&ts=true"
import script from "./resourceImgVideo.vue?vue&type=script&lang=ts"
export * from "./resourceImgVideo.vue?vue&type=script&lang=ts"

import "./resourceImgVideo.vue?vue&type=style&index=0&id=113b3b44&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113b3b44"]])

export default __exports__